import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        return;
      }

      $( '.treatment-planner-cta' ).each( function() {
        const gradients = $( this ).find( '.js-treatment-planner-gradient' ).toArray();

        if ( !gradients.length ) {
          return;
        }

        gsap.set( gradients, {transformOrigin: 'center center'} );

        gsap.timeline( {repeat: -1, yoyo: true, defaults: {duration: 2.4, ease: 'sine.inOut'}} )
            .fromTo(
                gradients[0],
                {scale: 1.18},
                {scale: 0.86},
                0,
            )
            .fromTo(
                gradients[1],
                {scale: 0.86},
                {scale: 1.18},
                0,
            );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatment-planner-cta', COMPONENT );
} )( app );
